module.exports = __webpack_public_path__ + "img/tema-1-16.3555ee53.png";